var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right_"},[_c('div',{staticClass:"right_child",on:{"click":_vm.goBackTop}},[_vm._v("返回顶部")])])
}
var staticRenderFns = []

export { render, staticRenderFns }